import { useEffect, useRef } from 'react';

/**
 * Runs an effect only when its dependencies change after the first render, never on mount.
 * Uses a ref to skip the initial effect run, calls effect on later runs, and returns the optional
 * cleanup from every run.
 *
 * @param effect - Effect to run on dependency updates.
 * @param dependencies - Values whose changes trigger the effect.
 * @param cleanup - Optional cleanup returned from the effect.
 * @returns Nothing.
 */
export default function useUpdateEffect(
  effect: (...args: any[]) => any,
  dependencies: any[] = [],
  cleanup?: any,
) {
  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      effect();
    }
    return cleanup;
  }, dependencies);
}
